import { useState } from 'react';

import { putInLocalStorage } from 'widget/actions';
import { useRequest } from 'widget/hooks';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import useInitialAccessToken from './use-initial-access-token/use-initial-access-token';

const useAccessToken = () => {
  const { widget } = useWidgetContext();

  const initialAccessToken = useInitialAccessToken();

  const [accessToken, setAccessToken] = useState<string | null | undefined>(
    initialAccessToken,
  );

  const { postAuthRegister } = useRequest();

  const createAccessToken = async (guest?: Env.Guest) => {
    if (!widget.instance_chat_key) {
      setAccessToken(null);
      return null;
    }

    const res = await postAuthRegister(widget.instance_chat_key, guest);
    setAccessToken(res?.access_token || null);

    if (!res) return null;

    putInLocalStorage(
      `whatcrmWidgetAccessToken${widget.instance_chat_key}`,
      res.access_token,
    );

    putInLocalStorage(
      `whatcrmWidgetUserId${widget.instance_chat_key}`,
      res.user_id,
    );

    return res.access_token;
  };

  return { accessToken, createAccessToken, setAccessToken };
};

export default useAccessToken;
